














import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import DsrUnavailable from '@getaccept/lib-shared/src/lobby/components/DsrUnavailable.vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import IdentifyParticipant from './IdentifyParticipant.vue';

export default defineComponent({
  components: {
    IdentifyParticipant,
    DsrUnavailable,
  },
  props: {
    consentSteps: {
      default: () => [],
      type: Array as PropType<AuthenticationStep[]>,
    },
    nextAuthStep: {
      type: Object as PropType<AuthenticationStep>,
      default: () => ({}),
    },
    submittingResponse: {
      type: Boolean,
    },
    showDsrUnavailable: {
      type: Boolean,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      default: () => ({}),
    },
  },
  setup(props) {
    const documentLogoUrl = computed(() => BrandingHelper.getLogoUrl(props.theme));

    return {
      documentLogoUrl,
      AuthenticationStepType,
      t,
    };
  },
});
